import React from 'react';

export default class MenuItemActionList extends React.Component {
    render() {
        return <ul className="menu__item menu__item--action-list">{this.props.children}</ul>;
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/MenuItemActionList.jsx